import React from 'react'
import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

import kinoraLogo from '@shared-assets/kinora_logo.svg'

/** Minimal sticky marketing header — logo left, auth right.
    Shared by all marketing routes (/, /about, /pricing, /guild, legal pages). */
const MarketingHeader = () => {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useAuth()

  return (
    <header className="sticky top-0 z-50 border-b border-border/20 bg-background/85 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <img
          src={kinoraLogo}
          alt="Kinora"
          className="h-7 w-auto select-none cursor-pointer"
          draggable={false}
          onClick={() => navigate('/')}
        />
        {!isLoading && (
          <div className="flex items-center gap-2">
            {isAuthenticated ? (
              <Button
                size="sm"
                className="text-sm px-5"
                onClick={() => navigate('/home')}
              >
                Go to Home
                <ArrowRight className="w-4 h-4 ml-1.5" />
              </Button>
            ) : (
              <>
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-sm hidden sm:inline-flex"
                  onClick={() => navigate('/auth')}
                >
                  Sign In
                </Button>
                <Button
                  size="sm"
                  className="text-sm px-5"
                  onClick={() => navigate('/auth')}
                >
                  Get Started
                </Button>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  )
}

export default MarketingHeader
